import PropTypes from 'prop-types'
import React, { Component } from 'react'
import CONSTANTS from '../../constants/index'
import { Link } from 'react-router'
import './gp-web-questions.css'

export default class GPWebAdPlans extends Component {
  detailsToggleHandler = (event) => {
    if (this.props.onToggle) {
      this.props.onToggle(event)
    }
  };

  componentDidMount() {
    document.querySelectorAll('.ad-accordion').forEach((details) => {
      details.addEventListener('toggle', this.detailsToggleHandler);
    });
  }

  componentWillUnmount() {
    document.querySelectorAll('.ad-accordion').forEach((details) => {
      details.removeEventListener('toggle', this.detailsToggleHandler);
    });
  }

  generateLinkMarkup = (url, text) => {
    let markup = ''

    if (url && text) {
      markup = `<a class="terms_link" href="${url}" target="_blank">${text}</a>`
    } else if (!url && text) {
      markup = text
    }

    return markup
  }

  generateSiteLocaleLink = (pageData, locale, key) => {
    const localeFormatted = locale.replace('-', '_')

    if (pageData && pageData.locales && pageData.locales[localeFormatted]) {
      if (pageData.locales[localeFormatted][key]) {
        return pageData.locales[localeFormatted][key]
      }
    } else if (pageData[key]) {
      return pageData[key]
    }

    return false
  }

  render() {
    const { t } = this.props

    const termsLink = this.generateLinkMarkup(
      this.generateSiteLocaleLink(CONSTANTS.PAGES, CONSTANTS.LOCALE, 'terms_and_conditions'),
      t('TERMS_AND_CONDITIONS'),
    )

    /* eslint-disable */
    return (
      <div className="ad-questions">
        <div className="ad-questions__title">{t('GP_QA_TITLE')}</div>
        <details className="ad-accordion">
          <summary className="ad-accordion__header">
            <p className="ad-accordion__title">{t('GP_QA_QUESTION_1')}</p>
          </summary>
          {(() => {
            const answer1Html = `${t('GP_QA_ANSWER_1_PART1')}<a href="/privacy-notice">${t('PRIVACY_POLICY')}</a>${t('GP_QA_ANSWER_1_PART2')}`;
            return (
              <p
                className="ad-accordion__summary"
                dangerouslySetInnerHTML={{ __html: answer1Html }}
              />
            );
          })()}
        </details>
        <details className="ad-accordion">
          <summary className="ad-accordion__header">
            <p className="ad-accordion__title">{t('GP_QA_QUESTION_2')}</p>
          </summary>
          <p className="ad-accordion__summary">
            <span dangerouslySetInnerHTML={{ __html: t('GP_QA_ANSWER_2_PART1') }}/>
            <Link to={`/gp-web/signin${this.props.location.search}`} className="ad-plans-login_cta">{t('HERE')}</Link>
            {t('GP_QA_ANSWER_2_PART2')}
          </p>
        </details>
        <details className="ad-accordion">
          <summary className="ad-accordion__header">
            <p className="ad-accordion__title">{t('GP_QA_QUESTION_3')}</p>
          </summary>
          <p className="ad-accordion__summary">
            {t('GP_QA_ANSWER_3_PART1')}
            <Link to={`/gp-web/signin${this.props.location.search}`} className="ad-plans-login_cta">{t('HERE')}</Link>
            {t('GP_QA_ANSWER_3_PART2')}
          </p>
        </details>
        <details className="ad-accordion">
          <summary className="ad-accordion__header">
            <p className="ad-accordion__title">{t('GP_QA_QUESTION_5')}</p>
          </summary>
          <p className="ad-accordion__summary">
            {t('GP_QA_ANSWER_5_PART1')}
            <span dangerouslySetInnerHTML={{__html: termsLink}} />
            {t('GP_QA_ANSWER_5_PART2')}
          </p>
        </details>
        <details className="ad-accordion">
          <summary className="ad-accordion__header">
            <p className="ad-accordion__title">{t('GP_QA_QUESTION_4')}</p>
          </summary>
          <p className="ad-accordion__summary">
            {t('GP_QA_ANSWER_4_PART1')}
            {t('GP_QA_ANSWER_4_PART2')}
          </p>
        </details>
      </div>
    )
    /* eslint-enable */
  }
}

GPWebAdPlans.propTypes = {
  t: PropTypes.func.isRequired,
}

GPWebAdPlans.defaultProps = {
}




// WEBPACK FOOTER //
// ./src/components/gp-web-questions/gp-web-questions.js